module.exports = __webpack_public_path__ + "img/adv_easy.764d44ee.png";